import { createSelector } from 'reselect';
import { getSelectedAoi } from 'store/selectors/index';
import { Map as ImmutableMap } from 'immutable';

// ——— Input Selectors ———


// All defined layers in the app
const getAllLayers = (state) => state.layers.get('layers');

// All available scripts
const getScriptsInfo = (state) => state.statistics.get('scriptsInfo');


// ——— Derived Selectors ———

// 1. Scripts explicitly attached to the AOI
const getAoiScripts = createSelector(
  [ getSelectedAoi, getScriptsInfo ],
  (selectedAoi, scriptsInfo) => {
    const result = new Map();

    // Grab script IDs listed in the AOI
    const aoiScriptIds = selectedAoi?.get('scripts')?.toArray() || [];
    aoiScriptIds.forEach((scriptId) => {
      const script = scriptsInfo.get(scriptId);
      if (script) {
        result.set(scriptId, script);
      }
    });

    return result;
  }
);

// 2. Scripts referenced by layers in the AOI
const getLayerScripts = createSelector(
  [ getSelectedAoi, getAllLayers, getScriptsInfo ],
  (selectedAoi, allLayers, scriptsInfo) => {
    const result = new Map();

    // Extract AOI’s layer IDs
    const aoiLayers = selectedAoi?.get('layers')?.toArray() || [];
    const aoiLayerIds = aoiLayers.map((layer) => layer.get('id'));

    // For each layerId, check if it has area-stats and a scriptId
    aoiLayerIds.forEach((layerId) => {
      const layerDef = allLayers.get(layerId);
      const hasStats = layerDef?.get('layerWithAreaStats');

      if (hasStats === true ) {
        result.set(layerId, layerDef );
      }
    });

    return result;
  }
);


// 3. Combine both sets of scripts into a single Map
export const getScripts = createSelector(
  [ getAoiScripts, getLayerScripts ],
  (aoiScripts, layerScripts) => {
    // Merge Maps via spread syntax, convert to ImmutableMap!
    return new ImmutableMap([
      ...aoiScripts,
      ...layerScripts
    ]);
  }
);


// ——— Other Simple Selectors ———

export const getPreSelectedScripts = (state) => state.statistics.get('preSelectedScripts');

export const getStatisticsDrawerOpen = (state) => state.statistics.get('drawerOpen');

export const getSelectedTab = (state) => state.statistics.get('selectedTab');
